import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';

import { EAlertType } from '../../../repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';
import { TThunkAction } from '../../../types/redux';
import { getUser } from '../getUser';

export { EAlertType };

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
  /** Перезагрузить страницу после успешной авторизации */
  autoRefresh?: boolean;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return (dispatch, _getState, { microfrontendsAPI }) => {
    // API шапки есть только в браузере
    if (!microfrontendsAPI) {
      return;
    }

    const consumer = getUserConsumer();

    const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
      if (event.type === 'authenticated') {
        await dispatch(getUser());

        /* istanbul ignore else */
        if (window.__reloadHeader__) {
          window.__reloadHeader__();
        }

        /* istanbul ignore else */
        if (parameters?.onSuccess) {
          dispatch(parameters.onSuccess());
        }

        consumer.unsubscribe(userSubscriber);

        return;
      }

      if (event.type === 'authentication_modal_closed') {
        /* istanbul ignore else */
        if (parameters?.onCloseNoAuth) {
          dispatch(parameters.onCloseNoAuth());
        }

        consumer.unsubscribe(userSubscriber);
      }
    });

    consumer.subscribe(userSubscriber);

    void microfrontendsAPI.header.openAuthModal({
      autoRefresh: parameters?.autoRefresh ?? false,
      alert: parameters?.alert ?? null,
      useDefaultView: false,
      viewData: null,
      source: null,
    });
  };
}
